import React, { useCallback } from "react";

import { ChangeJobPriorityButtonModal } from "./../Dialogs";
import { ChangePriority } from "../../../../components/svg/svgImageList";
import { ChangeJobPriority as PermissionChangePriority } from "../../../../services/authorization/Permissions";
import Button from "../../../../components/button/Button";
import useThemeService from "../../../../services/theme-service/ThemeService";
import useModal from "../../../../components/dialog/useModal";
import { permissionsService } from "../../../../services/authorization/UserPermissionsService";
import { MultipleJobsActionProps } from "./MultipleJobsActionProps";

export function ChangeJobPriorityButton(props: MultipleJobsActionProps) {
  const { themeClass } = useThemeService();

  const { isVisible, toggleModal } = useModal();

  const { jobsStorage } = { ...props };

  const isDisabled = useCallback(
    () =>
      !permissionsService.userHasPermissionTo(PermissionChangePriority) ||
      !jobsStorage.anyItemsSelected,
    [jobsStorage.anyItemsSelected]
  );

  return (
    <>
      <Button
        icon={{
          svg: ChangePriority,
          textKey: "jobs.ChangeJobPriorityButton.label",
          textClass: "actions-header-button-label",
          className: themeClass(["icon-change-priority"]),
        }}
        disabled={isDisabled()}
        onClick={toggleModal}
      />
      <ChangeJobPriorityButtonModal
        isVisible={isVisible}
        toggleModal={toggleModal}
        jobsStorage={jobsStorage}
      />
    </>
  );
}
